<template>
  <div class="modal fade" id="selectRowTypeModal">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Template Rows</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="saveRowType">
            <div style="form-group">
              <label>Row Type</label>
              <select
                name="rowTypePicker"
                class="selectpicker form-control"
                data-live-search="true"
                data-actions-box="true"
                v-model="rowType"
                v-on:change="updateRowType"
              >
                <option disabled value="">
                  Select a Row Type
                </option>
                <option
                  v-for="row in budgetRowTypes"
                  :key="row.description"
                  v-bind:value="row"
                >
                  {{ row.description }}
                </option>
              </select>
            </div>
            <div
              class="form-group px-1 mt-2"
              style="border: 0.1rem solid gray; border-radius: 4px;"
            >
              <table class="table">
                <tbody>
                  <tr
                    v-for="(row, index) in rows.filter(r => r.h == true)"
                    :key="index"
                    v-bind:class="{ 'header-row': row.h == true }"
                  >
                    <td v-for="(col, index) in row.c" :key="index">
                      <input
                        v-if="!col.sum"
                        class="form-control"
                        v-model="col.v"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="text-right">
              <button class="btn btn-primary">
                Select Row Type
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { budgetRowTypes } from "@/constants/BudgetRowTypes";

export default {
  name: "SelectRowTypeModal",
  props: {},
  data() {
    return {
      rows: [],
      budgetRowTypes: budgetRowTypes,
      rowType: ""
    };
  },
  mounted() {
    $("select").selectpicker();
  },
  methods: {
    saveRowType() {
      this.$emit("selectedRowType", this.rows, this.rowType);
    },
    updateRowType() {
      this.rows = this.rowType.value;
    },
    addHeaderRow() {
      this.rows.push({
        c: [],
        h: true
      });
    },
    addDataRow() {
      this.rows.push({
        c: [],
        h: false
      });
    },
    addCol(rowNum) {
      var nextOrder = 1;
      var rowIndex = this.rows.findIndex(r => r.o == rowNum);
      if (this.rows[rowIndex].c.length > 0) {
        nextOrder = Math.max(...this.rows[rowIndex].c.map(c => c.o)) + 1;
      }
      this.rows[rowIndex].c.push({
        o: nextOrder,
        v: "New Column"
      });
    }
  }
};
</script>

<style scoped></style>
